export enum Permissions {
  IS_ADMIN = 'IS_ADMIN',

  CAN_READ_ROLES = 'CAN_READ_ROLES',
  CAN_WRITE_ROLES = 'CAN_WRITE_ROLES',

  CAN_READ_USERS = 'CAN_READ_USERS',
  CAN_WRITE_USERS = 'CAN_WRITE_USERS',

  CAN_READ_CORP_SETTINGS = 'CAN_READ_CORP_SETTINGS',
  CAN_EDIT_CORP_SETTINGS = 'CAN_EDIT_CORP_SETTINGS',
  CAN_DELETE_CORP = 'CAN_DELETE_CORP',

  CAN_READ_HIERARCHY_SETTINGS = 'CAN_READ_HIERARCHY_SETTINGS',
  CAN_EDIT_HIERACHY_SETTINGS = 'CAN_EDIT_HIERACHY_SETTINGS',
  CAN_DELETE_HIERARCHY = 'CAN_DELETE_HIERARCHY',
  CAN_ADD_HIERARCHY = 'CAN_ADD_HIERARCHY',

  CAN_READ_BOT_ANALYTICS = 'CAN_READ_BOT_ANALYTICS',
  CAN_READ_BOT_CONVERSATION_LOGS = 'CAN_READ_BOT_CONVERSATION_LOGS',
  CAN_READ_BOT_SETTINGS = 'CAN_READ_BOT_SETTINGS',
  CAN_EDIT_BOT_SETTINGS = 'CAN_EDIT_BOT_SETTINGS',

  CAN_HANDLE_BOT_SUPPORT = 'CAN_HANDLE_BOT_SUPPORT',
  CAN_ADMIN_BOT_HIL = 'CAN_ADMIN_BOT_HIL',
  CAN_EXPORT_BOT = 'CAN_EXPORT_BOT',
  CAN_DELETE_BOT = 'CAN_DELETE_BOT',
  CAN_ADD_BOT = 'CAN_ADD_BOT',
  CAN_ACCESS_KNOWLEDGE_BANK = 'CAN_ACCESS_KNOWLEDGE_BANK',

  ACCESS_ALL_COMPANIES = 'ACCESS_ALL_COMPANIES',

  CAN_VIEW_CONVERSATION_ID_HIL = 'CAN_VIEW_CONVERSATION_ID_HIL',
}
// Stricter permissions First
export const DependentPermissions = [
  [Permissions.CAN_WRITE_ROLES, Permissions.CAN_READ_ROLES],
  [Permissions.CAN_WRITE_USERS, Permissions.CAN_READ_USERS],
  [Permissions.CAN_EDIT_CORP_SETTINGS, Permissions.CAN_READ_CORP_SETTINGS],
  [Permissions.CAN_DELETE_CORP, Permissions.CAN_READ_CORP_SETTINGS],
  [Permissions.CAN_EDIT_HIERACHY_SETTINGS, Permissions.CAN_READ_HIERARCHY_SETTINGS],
  [Permissions.CAN_DELETE_HIERARCHY, Permissions.CAN_READ_HIERARCHY_SETTINGS],
  [Permissions.CAN_EDIT_BOT_SETTINGS, Permissions.CAN_READ_BOT_SETTINGS],
  [Permissions.CAN_DELETE_BOT, Permissions.CAN_READ_BOT_SETTINGS],
];
